import React from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import SectionBadge from "@/components/SectionBadge";

const SecuritySection = () => {
  const { t } = useLang();
  return (
    <section
      id="seguranca"
      data-testid="security-section"
      className="relative py-24 lg:py-28 border-y border-[#1dc7e9]/10"
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-grid opacity-30 pointer-events-none"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          <div className="lg:max-w-md">
            <SectionBadge icon={Lock}>Segurança</SectionBadge>
            <h2 className="mt-5 text-2xl sm:text-3xl lg:text-4xl font-bold leading-[1.1] tracking-tight text-white text-balance">
              {t.security.title}
            </h2>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-3 w-full">
            {t.security.items.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                className="rounded-xl p-4 border border-[#1dc7e9]/15 bg-white/[0.02] hover:border-[#1dc7e9]/45 transition-all duration-300"
                data-testid={`security-card-${i}`}
              >
                <div className="text-white font-bold tracking-tight text-base">
                  {s.label}
                </div>
                <div className="text-[11.5px] text-[#b8c0cc] mt-1">{s.desc}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
